export default {
  ctaText: "Show my financial overview",
  sidePanelSubtitle:
    "These are the evening results.",
  sidePanelTitle: "Results!",
  tagLabel: "Evening"
};
